import { Route } from "react-router-dom";
import CreateStartup from "@/pages/CreateStartup";
import EditStartup from "@/pages/EditStartup";
import StartupDetails from "@/pages/StartupDetails";
import StartupDashboard from "@/pages/StartupDashboard";
import Startups from "@/pages/Startups";

export const startupRoutes = [
  <Route key="startups" path="/communities/startups" element={<Startups />} />,
  <Route key="startup-create" path="/communities/startups/create" element={<CreateStartup />} />,
  <Route key="startup-dashboard" path="/communities/startups/dashboard" element={<StartupDashboard />} />,
  <Route key="startup-edit" path="/communities/startups/:id/edit" element={<EditStartup />} />,
  <Route key="startup-details" path="/communities/startups/:id" element={<StartupDetails />} />,
];